import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { getURLs as getURLsAction } from './server';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

export const useGetURLs = () => {
    const { creferer } = useUserSelector(prop('userDetails'));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const { casinoName, clientSkin, clientType, errorLevel } =
        useAppSelector(pick(['casinoName', 'clientSkin', 'clientType', 'errorLevel']));

    return useCallback((payload) => {
        const getURLs = getURLsAction({ clientPlatform, casinoName, clientSkin, clientType, creferer, errorLevel });

        return getURLs(payload);
    }, [clientPlatform, casinoName, clientSkin, clientType, creferer, errorLevel]);
};
